import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { CardBody } from "reactstrap";
import CommonButton from "../../../../Components/Common/CommonButton/CommonButton";
import UpdateConfirmationModal from "../Modal/UpdateConfirmationModal";
import SaveConfirmationModal from "../Modal/SaveConfirmationModal";
import {
  resetFormState,
  setSelectValidError,
  verifyModal,
} from "../../../../slices/common/reducer";
import {
  ProductModalLayoutJSON,
  SubscriptionModalLayoutJSON,
  UploadLayoutJSON,
} from "../Json/ProductLayoutJson";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import {
  createProduct,
  getProductData,
  updateProduct,
} from "../ProductService";
import { checkButtonAccess, getOrgId } from "../../../../Utils/CommonUtils";
import { useState } from "react";
import HubDocuments from "../../../../Components/Common/Documents/HubDocuments";
import {
  SubscriptionModalFieldsJSON,
  UploadFieldsJSON,
} from "../Json/ProductFieldsJson";
import Fieldset from "../../../../Components/Common/Fieldset/Fieldset";

const Details = () => {
  const dispatch = useDispatch();
  const productFieldJson = useSelector(
    (state) => state.product.productFieldJson
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const data = useSelector(
    (state) => state.product.selectedProduct.detailsData
  );
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const navigator = useNavigate();
  const params = useParams();
  const editMode = !!params.id;
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationid = selectedUser.organizationid;
  const [isEditing, setIsEditing] = useState({});
  const [filesFetched, setFilesFetched] = useState(false);
  // const files = useSelector((state) => state.oem.selectedOem.detailsData.file || {});
  const files = useSelector(
    (state) => state.product.selectedProduct.detailsData.file || {}
  );

  const addNewClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const handleCancel = () => {
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
    dispatch(verifyModal(false));
    navigator("/prod/product");
  };

  const confirmSave = (e) => {
    e.preventDefault();
    if (
      formState.product_type &&
      formState.product_category &&
      formState.product_plan &&
      formState.product_attributes &&
      formState.subscription_type
    ) {
      dispatch(setSelectValidError(false));
      createProduct("PPET", formState, organizationid, navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  const confirmUpdate = (e) => {
    e.preventDefault();
    if (
      formState.product_type &&
      formState.product_category &&
      formState.product_plan &&
      formState.product_attributes &&
      formState.subscription_type
    ) {
      dispatch(setSelectValidError(false));
      updateProduct(formState, params.id, navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  useEffect(() => {
    getProductData(params.id, "PPET");
  }, []);

  const toggleEdit = (fieldKey) => {
    setIsEditing((prev) => ({
      ...prev,
      [fieldKey]: !prev[fieldKey],
    }));
  };

  return (
    <div>
      <Form
        onSubmit={editMode ? updateClickHandler : addNewClickHandler}
        // onKeyDown={(e) => {
        //   if (e.key === "Enter") {
        //     // editMode ? updateClickHandler(e) : addNewClickHandler(e);
        //     editMode ? confirmUpdate(e) : confirmSave(e);
        //   }
        // }}
      >
        <CardBody className="form-content">
          <div className="selected-tab-bottom-content">
            <Fieldset title={"Product Details"} />
            {ProductModalLayoutJSON.map((element) => (
              <div key={element.elementid}>
                {element.child.map((child) =>
                  renderElement(child, productFieldJson, formState)
                )}
              </div>
            ))}

            <Fieldset title={"Subscription Details"} />
            {SubscriptionModalLayoutJSON.map((element) => (
              <div key={element.elementid}>
                {element.child.map((child) =>
                  renderElement(child, SubscriptionModalFieldsJSON, formState)
                )}
              </div>
            ))}
          </div>
          <div className="form-footer">
            <CommonButton
              // handleSubmit={editMode ? updateClickHandler : addNewClickHandler}
              handleCancel={handleCancel}
              edit={editMode}
              update={editMode}
              checkAccess={checkButtonAccess("EDIT", "PROD_PRO")}
            />
          </div>
          {verifyShow &&
            (editMode ? (
              <UpdateConfirmationModal confirmUpdate={confirmUpdate} />
            ) : (
              <SaveConfirmationModal confirmUpdate={confirmSave} />
            ))}
        </CardBody>
      </Form>
    </div>
  );
};

export default Details;
